"use client";
import { useCallback, useEffect, useMemo, useState } from "react";
import { AssetColumns, Assets } from "./AssetColumns"
import { DataTable } from "../../dataTables/data-table"
import { deteleAsset, fetchAssets } from "@/apiCalls/apiCalls"
import { Button } from "@/components/ui/button"
import AssetDrawer from "./CreateAssetDrawer"
import Spinner from "../spinnner/Spinner"
import AssetUpdateDrawer from "./AssetUpdateDrawer";
import { errorNotification, successNotification } from "@/utils/Notification";
import { useLocation, useNavigate } from "react-router-dom";
import useAxiosPrivate from "@/context/UseAxiosPrivate";
import useAuth from "@/hooks/useAuth";
import { jwtDecode } from "jwt-decode"
import { AssetDataTables } from "./AssetDataTables";
import ActivateVehicleMain from "../ActivateVehicle/ActivateVehicleMain";
import axios from "axios";

export default function AssetsFn() {
    const [data, setData] = useState<Assets[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [showDrawer, setShowDrawer] = useState(false);
    const [updateAssetShowDrawer, setUpdateAssetShowDrawer] = useState(false);
    const [assetData, setAssetData] = useState<Assets | undefined>(undefined);
    const [activateVehicleDialog, setActivateVehicleDialog] = useState<boolean>(false)
    const [showMainActivateDrawer, setShowMainActivateDrawer] = useState<boolean>(false)

    const navigate = useNavigate();
    const location = useLocation();
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth()
    let token: any = auth.accessToken
    const decoded: any = jwtDecode(token);
    let roles: string[] = decoded.UserInfo.roles
    const requiredActivateVehicleRoles: string[] = ['asset-edit', 'beacon-edit', 'billings-edit']

    const getAssets = () => {
        setLoading(true)
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get('/api/v1/assets', {
            signal: controller.signal
        }).then((response: any) =>
            response.data.data
        ).then((data: Assets[]) => {
            if (isMounted) {
                setData(data)

            }
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
           
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                console.log("tshsssssssssssssss",err)
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        }).finally(() => {
            setLoading(false)
        })
        return () => {
            isMounted = false
            controller.abort()
        };
    }

    useEffect(() => {
        getAssets()
    }, [])

    const getClientIPAndURL = async () => {
        try {

            const response = await axios.get('https://api.ipify.org?format=json');
            const clientIp = response.data.ip
            const currentUrl = window.location.href
            return { clientIp, currentUrl }
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return { clientIp: 'Unknown', currentUrl: window.location.href }
        }
    }

    const deleteAssetById = (assetId: any) => {
        let isMounted = true;
        const controller = new AbortController()
        getClientIPAndURL().then(({ clientIp, currentUrl }) => {
            return axiosPrivate.delete(`/api/v1/assets/${assetId}`, {
                signal: controller.signal,
                headers: {
                    'X-Client-IP': clientIp,
                    'X-Origin-URL': currentUrl
                }
            })
        }).then((data: any) => {
            if (isMounted) {
                successNotification(
                    "assets successfully deleted",
                    "asset deleted",
                    'topRight'
                )

            }
            getAssets()
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };


    const editFunctionCall = (Asset: Assets) => {
        setAssetData(Asset)
        setUpdateAssetShowDrawer(!updateAssetShowDrawer)
    }

    const deleteFunctionCall = async (Asset: Assets) => {
        deleteAssetById(Asset.id)
    }
    const activateVehicleFunctionCall = async (Asset: Assets) => {
        setAssetData(Asset)
        setShowMainActivateDrawer(!showMainActivateDrawer)
    }




    const onActivateVehicle = useCallback(
        (assets: Assets) => activateVehicleFunctionCall(assets),
        []
    )




    const onDelete = useCallback(
        (assets: Assets) => deleteFunctionCall(assets),
        []
    )

    const onEdit = useCallback(
        (assets: Assets) => editFunctionCall(assets),
        []
    )



    const AssetColumnsData = useMemo(() => AssetColumns({ onEdit, onDelete, onActivateVehicle, roles }), [])

    if (loading) {
        return <Spinner />;
    }

    return (
        <main className='mx-3 mt-16 sm:ml-[300px] sm:mt-3'>

            {roles.includes('asset-create') && (
                <Button
                    variant='default'
                    className="flex items-center justify-end"
                    onClick={() => setShowDrawer(!showDrawer)}
                >
                    Create Assets
                </Button>
            )}


            <AssetDataTables columns={AssetColumnsData} data={data} filterNameColumn='registration' />

            {roles.includes('asset-create') && showDrawer && (
                <AssetDrawer
                    showDrawer={showDrawer}
                    setShowDrawer={setShowDrawer}
                    getAssets={getAssets}
                />
            )}




            {assetData && roles.includes('asset-edit') && (
                <AssetUpdateDrawer
                    updateAssetShowDrawer={updateAssetShowDrawer}
                    setUpdateAssetShowDrawer={setUpdateAssetShowDrawer}
                    Assets={assetData}
                    getAssets={getAssets}
                    setAssetData={setAssetData}
                />
            )}

            {assetData && requiredActivateVehicleRoles.every((role: string) => roles.includes(role)) && (
                <ActivateVehicleMain
                    showMainActivateDrawer={showMainActivateDrawer}
                    setShowMainActivateDrawer={setShowMainActivateDrawer}
                    getAssets={getAssets}
                    Assets={assetData}
                    setAssetData={setAssetData}
                />
            )}


        </main>
    )
}